import { useState, useEffect, useCallback } from 'react'
import { useApi } from '@/lib/api'
import type { FunctionalRoleConfiguration } from '@/types/api/functional-role'

export function useFunctionalRoles() {
  const { mainApi } = useApi()
  const [roles, setRoles] = useState<FunctionalRoleConfiguration[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false

    const fetchRoles = async () => {
      try {
        setLoading(true)
        setError(false)
        const data = await mainApi.get<FunctionalRoleConfiguration[]>('api/FunctionalRoleConfiguration')
        if (!cancelled) {
          if (Array.isArray(data)) {
            setRoles(data)
          } else {
            setError(true)
          }
        }
      } catch (err) {
        console.error('Failed to fetch functional role configuration:', err)
        if (!cancelled) setError(true)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchRoles()
    return () => { cancelled = true }
  }, [mainApi])

  const isRestrictedAccess = useCallback(
    (roleId: number) => roles.some(r => r.FunctionalRoleId === roleId && r.IsRestrictedAccess),
    [roles]
  )

  return { loading, error, isRestrictedAccess }
}
